export const getSimilarDesignerNames = (designers: { id: string; count: number }[]): string[] => {
  if (designers.length === 0) {
    return [];
  }
  return designers.map(designer => designer?.id);
};
